// extracted by mini-css-extract-plugin
module.exports = {"ImageWrapper":"Modal_ImageWrapper__3Gu4E","ShadowWrapper":"Modal_ShadowWrapper__ZqGQG","Active":"Modal_Active__2gEL9","Shadow":"Modal_Shadow__3moWZ"};